import { render, staticRenderFns } from "./ConversationBodyComponent.vue?vue&type=template&id=2699f34e&"
import script from "./ConversationBodyComponent.vue?vue&type=script&lang=js&"
export * from "./ConversationBodyComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBodyComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports